export default "__VITE_ASSET__Cw52aGxE__"